import { $ } from "@/common/Axios";

export default {
  /**
   * 微信配置
   */
  wechatConfig_refresh: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/extension/wechatConfig/refresh", p, c),
  },
  wechatConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechatConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/wechatConfig", p, c),
  },
  wechatConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatConfig/list", p, c),
  },
  wechatConfig_listPlatform: {
    /*
     * 平台列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatConfig/listPlatform", p, c),
  },

  /**
   * 行政区域
   */
  region_setStreet: {
    /*
     * 设置街道
     * province 省份 (string query required)
     * city 城市 (string query required)
     * district 区县 (string query required)
     * streets 街道 (array query required)
     */
    put: (p, c) => $.put("/api/bms/extension/region/setStreet", p, c),
  },
  region: {
    /*
     * 添加
     * region  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/region", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/region", p, c),
  },
  region_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/region/upload", p, c),
  },
  region_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/region/list", p, c),
  },
  region_listStreet: {
    /*
     * 查询街道列表
     * province 省份 (string query required)
     * city 城市 (string query required)
     * district 区县 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/region/listStreet", p, c),
  },
  region_listProvince: {
    /*
     * 查询省份列表
     */
    get: (p, c) => $.get("/api/bms/extension/region/listProvince", p, c),
  },
  region_listDistrict: {
    /*
     * 查询区县列表
     * province 省份 (string query required)
     * city 城市 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/region/listDistrict", p, c),
  },
  region_listCity: {
    /*
     * 查询城市列表
     * province 省份 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/region/listCity", p, c),
  },
  region_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/region/export", p, c),
  },

  /**
   * 扩展（其他）
   */
  other_initRedis: {
    /*
     * 根据key初始化值
     * title 类型 (string query required)
     * adminId 管理员id (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/other/initRedis", p, c),
  },
  other_uploadImageByteToServer: {
    /*
     * 上传图片byte到七牛
     * data 图片byte[] (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageByteToServer", p, c),
  },
  other_uploadImageBase64ToServer: {
    /*
     * 上传图片base64到服务器
     * base64  (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageBase64ToServer", p, c),
  },
  other_uploadImageBase64ToServerLocal: {
    /*
     * 上传图片base64到服务器，不传7牛
     * base64  (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageBase64ToServerLocal", p, c),
  },
  other_uploadFileToServer: {
    /*
     * 上传文件到服务器
     * subDirectory 保存文件子路径名字 (string query )
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/uploadFileToServer", p, c),
  },
  other_testBroadcastPerson: {
    /*
     * 测试个人业绩播报
     * info  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/testBroadcastPerson", p, c),
  },
  other_sendDingTalkMessage: {
    /*
     * 发送钉钉消息
     * adminId 管理员id (integer query required)
     * message 消息 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/sendDingTalkMessage", p, c),
  },
  other_sendDingTalkMassMessage: {
    /*
     * 发送钉钉消息-所有启用的管理员
     * message 消息 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/sendDingTalkMassMessage", p, c),
  },
  other_saveResource: {
    /*
     * 添加资源
     * md5String md5 (string query required)
     * fileName 文件名 (string query required)
     * cloudUrl 七牛地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/saveResource", p, c),
  },
  other_restoreRedisConfig: {
    /*
     * 恢复redis配置
     * key key (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/restoreRedisConfig", p, c),
  },
  other_putCache: {
    /*
     * 根据类型存入缓存
     * type 类型 (string query required)
     * content 内容 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCache", p, c),
  },
  other_putCacheByToken: {
    /*
     * 根据token和类型存入缓存
     * type 类型 (string query required)
     * content 内容 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCacheByToken", p, c),
  },
  other_putCacheByAdmin: {
    /*
     * 根据登录信息和类型存入缓存
     * type 类型 (string query required)
     * content 内容 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCacheByAdmin", p, c),
  },
  other_pay: {
    /*
     * 付款
     * payAccount 收款账号 (string query required)
     * amount 金额 (number query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/pay", p, c),
  },
  other_parseWord: {
    /*
     * 解析word（纯文本）
     * wordFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseWord", p, c),
  },
  other_parseWordTable: {
    /*
     * 解析word表格（多个表格以列表形式返回）
     * cellSplit 单元格分隔符 (string query required)
     * rowSplit 行分隔符 (string query required)
     * wordFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseWordTable", p, c),
  },
  other_parsePdf: {
    /*
     * 解析pdf
     * pdfFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parsePdf", p, c),
  },
  other_parseImg: {
    /*
     * 解析图片
     * url 图片地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseImg", p, c),
  },
  other_parseIdCard: {
    /*
     * 解析身份证
     * url 图片地址 (string query required)
     * cardSide 正面(front)｜反面(back) (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseIdCard", p, c),
  },
  other_getResourceByMd5: {
    /*
     * 根据MD5查询资源
     * md5String md5 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getResourceByMd5", p, c),
  },
  other_getFileMd5String: {
    /*
     * 查询文件MD5
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getFileMd5String", p, c),
  },
  other_getFileMd5String1: {
    /*
     * 查询文件MD5
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getFileMd5String1", p, c),
  },
  other_broadcastContinueEnroll: {
    /*
     * 继教院|服务部业绩汇报-上传图片服务器临时发送到群
     * type 类型：继教院|服务部|成教学习规划部|中军驻点线索 (string query required)
     * remoteUrl 七牛url (string query )
     * token 播报群token (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/broadcastContinueEnroll", p, c),
  },
  other_timestamp: {
    /*
     * 服务器时间戳
     */
    get: (p, c) => $.get("/api/bms/extension/other/timestamp", p, c),
  },
  other_searchTransferResp: {
    /*
     * 查询转账状态
     * payAccount 打款账号：公司支付宝 (string query required)
     * outBizNo 订单号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/searchTransferResp", p, c),
  },
  other_searchOrderInfo: {
    /*
     * 查询订单信息
     * payAccount 收款账号 (string query )
     * payAccountIdentity 收款账号 (string query )
     * orderNo 订单号 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/searchOrderInfo", p, c),
  },
  other_recordActualIp: {
    /*
     * 记录实际IP
     * key 密钥 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/recordActualIp", p, c),
  },
  other_parseQrCode: {
    /*
     * 二维码解析
     * imageUrl 二维码图片地址 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/parseQrCode", p, c),
  },
  other_listCardOrder: {
    /*
     * 获取安心付订单信息
     * payAccount 收款账号 (string query required)
     * shopId 门店 (string query required)
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/listCardOrder", p, c),
  },
  other_incrementRedis: {
    /*
     * 根据key获取值并自增
     * title 类型 (string query required)
     * adminId 管理员id (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/incrementRedis", p, c),
  },
  other_highRisk: {
    /*
     * 校验高危操作
     */
    get: (p, c) => $.get("/api/bms/extension/other/highRisk", p, c),
  },
  other_getWechatBill: {
    /*
     * 微信对账单
     * billDate 账单日期 (string query required)
     * payAccount 收款账号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getWechatBill", p, c),
  },
  other_getUpToken: {
    /*
     * 获取上传凭证
     * ext 文件扩展名 (string query required)
     * name 文件名 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/getUpToken", p, c),
  },
  other_getResourceUrlById: {
    /*
     * 根据id查询资源Url
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getResourceUrlById", p, c),
  },
  other_getRedis: {
    /*
     * 获取redis缓存
     * key key (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getRedis", p, c),
  },
  other_getPreDepartmentIdsTest: {
    /*
     * 查询PreDepartmentIds
     */
    get: (p, c) =>
      $.get("/api/bms/extension/other/getPreDepartmentIdsTest", p, c),
  },
  other_getPreAdminIdTest: {
    /*
     * 查询PreAdminId
     */
    get: (p, c) => $.get("/api/bms/extension/other/getPreAdminIdTest", p, c),
  },
  other_getMonthPerformance: {
    /*
     * 获取当月业绩
     * dingId 钉钉id (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getMonthPerformance", p, c),
  },
  other_getCache: {
    /*
     * 根据类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCache", p, c),
  },
  other_getCacheByToken: {
    /*
     * 根据token和类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCacheByToken", p, c),
  },
  other_getCacheByAdmin: {
    /*
     * 根据token和类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCacheByAdmin", p, c),
  },
  other_getAlipayBillUrl: {
    /*
     * 支付宝对账单
     * billDate 账单日期 (string query required)
     * payAccount 收款账号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getAlipayBillUrl", p, c),
  },
  other_downloadServerFile: {
    /*
     * 下载服务器文件
     * filePath 文件路径 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/downloadServerFile", p, c),
  },
  other_downloadEnrollLetter: {
    /*
     * 下载录取贺函
     * name 姓名 (string query required)
     * site 学校 (string query required)
     * level 层次 (string query required)
     * major 专业 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/downloadEnrollLetter", p, c),
  },
  other_douyin_clueQuery: {
    /*
     * 查询抖音本地生活线索
     * accountId 抖音账号ID (string query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     * page 页码 (integer query )
     * pageSize 每页条数 (integer query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/douyin/clue/query", p, c),
  },
  other_removeCache: {
    /*
     * 根据类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/other/removeCache", p, c),
  },
  other_removeCacheByToken: {
    /*
     * 根据token和类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/other/removeCacheByToken", p, c),
  },
  other_removeCacheByAdmin: {
    /*
     * 根据登录信息和类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/other/removeCacheByAdmin", p, c),
  },

  /**
   * 安心付周期卡
   */
  merchantCardTemplate_sync: {
    /*
     * 根据小程序id同步
     * msgAppId 小程序id (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardTemplate/sync", p, c),
  },
  merchantCardTemplate_modifyStatus: {
    /*
     * 上下架
     * id 周期卡id (integer query required)
     * operateStatus 状态：发布、下架 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/extension/merchantCardTemplate/modifyStatus", p, c),
  },
  merchantCardTemplate: {
    /*
     * 添加
     * cardTemplate  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/merchantCardTemplate", p, c),
  },
  merchantCardTemplate_setPeriodConfig: {
    /*
     * 设置安心付期数配置
     * config  (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/merchantCardTemplate/setPeriodConfig", p, c),
  },
  merchantCardTemplate_setContSelfPreFee: {
    /*
     * 设置职教自考生预交费用
     * fee 预交费用 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/merchantCardTemplate/setContSelfPreFee", p, c),
  },
  merchantCardTemplate_createCardInfoBySchoolRollId: {
    /*
     * 根据合同id创建安心付周期卡
     * schoolRollId 合同id (integer query required)
     * peroids 安心付期数 (array query required)
     * liveTime 有效期(小时) (integer query required)
     * feeType 收费单类型 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/bms/extension/merchantCardTemplate/createCardInfoBySchoolRollId",
        p,
        c
      ),
  },
  merchantCardTemplate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardTemplate/list", p, c),
  },
  merchantCardTemplate_getPeriod: {
    /*
     * 获取安心付期数
     * siteType 学校类型 (string query required)
     * batch 批次 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardTemplate/getPeriod", p, c),
  },
  merchantCardTemplate_getPeriodConfig: {
    /*
     * 获取安心付期数配置
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardTemplate/getPeriodConfig", p, c),
  },
  merchantCardTemplate_getContSelfPreFee: {
    /*
     * 获取职教自考生预交费用
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardTemplate/getContSelfPreFee", p, c),
  },
  merchantCardTemplate_getCardInfoBySchoolRollId: {
    /*
     * 根据合同id获取周期卡信息
     * schoolRollId 合同id (integer query required)
     * feeType 收费单类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/extension/merchantCardTemplate/getCardInfoBySchoolRollId",
        p,
        c
      ),
  },

  /**
   * 安心付周期卡售卖订单
   */
  merchantCardOrder_sync: {
    /*
     * 同步订单
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/sync", p, c),
  },
  merchantCardOrder_close: {
    /*
     * 关闭安心付周期卡订单
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/close", p, c),
  },
  merchantCardOrder_bind: {
    /*
     * 绑定
     * schoolRollId 合同id (integer query required)
     * feeType 收费单类型 (string query )
     * orderId 业务单ID (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/bind", p, c),
  },
  merchantCardOrder_create: {
    /*
     * 创建
     * cardTemplateId 安心付卡模板ID (string query required)
     * schoolRollId 合同编号 (integer query required)
     * feeType 收费单类型 (string query )
     * msgAppId 小程序id (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/merchantCardOrder/create", p, c),
  },
  merchantCardOrder_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardOrder/list", p, c),
  },
  merchantCardOrder_listSimple: {
    /*
     * 简易列表
     * schoolRollId 合同id (integer query required)
     * feeType 收费单类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardOrder/listSimple", p, c),
  },
  merchantCardOrder_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardOrder/export", p, c),
  },
  merchantCardOrder_detailsByOutOrderNo: {
    /*
     * 根据outOrderNo查询订单详情
     * outOrderNo outOrderNo (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardOrder/detailsByOutOrderNo", p, c),
  },

  /**
   * 安心付周期卡核销订单
   */
  merchantCardDeductionOrder_sync: {
    /*
     * 根据售卖订单id同步
     * cardOrderId 售卖订单id (integer query )
     */
    put: (p, c) =>
      $.put("/api/bms/extension/merchantCardDeductionOrder/sync", p, c),
  },
  merchantCardDeductionOrder_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/list", p, c),
  },
  merchantCardDeductionOrder_listByCardId: {
    /*
     * 根据售卖订单id获取核销订单列表
     * cardId 售卖订单id (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/listByCardId", p, c),
  },
  merchantCardDeductionOrder_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/export", p, c),
  },

  /**
   * 钉钉配置
   */
  dingtalkConfig_syncContinueStudent: {
    /*
     * 同步继教院学生（所有）
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/syncContinueStudent", p, c),
  },
  dingtalkConfig_refreshCache: {
    /*
     * 刷新缓存
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/refreshCache", p, c),
  },
  dingtalkConfig_refreshAttendance: {
    /*
     * 刷新考勤数据
     * attendanceId 考勤id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/refreshAttendance", p, c),
  },
  dingtalkConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalkConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/dingtalkConfig", p, c),
  },
  dingtalkConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/dingtalkConfig/list", p, c),
  },
  dingtalkConfig_listSimpleForContinue: {
    /*
     * 获取所有继教院钉钉配置
     */
    get: (p, c) =>
      $.get("/api/bms/extension/dingtalkConfig/listSimpleForContinue", p, c),
  },

  /**
   * 钉钉
   */
  dingtalk_syncOrganization: {
    /*
     * 同步部门和账号
     */
    put: (p, c) => $.put("/api/bms/extension/dingtalk/syncOrganization", p, c),
  },
  dingtalk_syncContinueStudent: {
    /*
     * 同步继教院学生
     * appConfigId 钉钉配置id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalk/syncContinueStudent", p, c),
  },
  dingtalk_uploadMedia: {
    /*
     * 上传钉钉文件
     * type 类型：image|voice|video|file (string query required)
     * path 路径 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/uploadMedia", p, c),
  },
  dingtalk_uploadMediaByStream: {
    /*
     * 上传媒体文件（文件流），返回mediaId
     * type 媒体类型(image/voice/file) (string query required)
     * file 文件 (string body required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/uploadMediaByStream", p, c),
  },
  dingtalk_sendGroupMessage: {
    /*
     * 发送群消息
     * token 机器人token (string query required)
     * msgType 消息类型：text|markdown (string query required)
     * title 标题(markdown类型必填) (string query )
     * content 内容 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/sendGroupMessage", p, c),
  },
  dingtalk_sendGroupFile: {
    /*
     * 发送群文件
     * openConversationId 群id (string query required)
     * mediaId 文件id (string query required)
     * fileName 文件名 (string query required)
     * fileType 文件类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/sendGroupFile", p, c),
  },
  dingtalk_sendDingOAMessage: {
    /*
     * 发送钉钉消息
     * adminId 接收人id (integer query required)
     * title 标题 (string query required)
     * content 内容 (string query required)
     * url 钉钉小程序链接 (string query required)
     * pcUrl PC端链接 (string query required)
     * appName 小程序名称 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/sendDingOAMessage", p, c),
  },
  dingtalk_sendDingMessage: {
    /*
     * 发送钉钉消息
     * adminId 接收人id (integer query required)
     * message 消息 (string query required)
     * appName 小程序名称 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/sendDingMessage", p, c),
  },
  dingtalk_refreshDingAccessToken: {
    /*
     * 刷新钉钉的AccessToken
     * appName App名称 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/refreshDingAccessToken", p, c),
  },
  dingtalk_postRequest: {
    /*
     * 钉钉post请求
     * appName App名称 (string query )
     * url 请求id (string query required)
     * keys 请求参数key (array query )
     * values 请求参数value (array query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/postRequest", p, c),
  },
  dingtalk_createSchedule: {
    /*
     * 创建日程
     * title 标题 (string query required)
     * content 内容 (string query required)
     * address 地址 (string query required)
     * reminderMinutes 多少分钟前提醒 (integer query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     * createId 创建人员 (integer query required)
     * adminIds 参与人员 (array query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/createSchedule", p, c),
  },
  dingtalk_createProcessInstance: {
    /*
     * 发起钉钉审批实例
     * processCode 审批流的唯一码 (string query required)
     * adminId 管理员id (integer query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     * names 表单项名字 (array query required)
     * values 表单项值 (array query required)
     * componentTypes 控件类型 (array query required)
     * approvalUserIds 审批人钉钉id (array query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/createProcessInstance", p, c),
  },
  dingtalk_changeScheduleMember: {
    /*
     * 添加或者删除日程参与者
     * createId 日程创建人 (integer query required)
     * scheduleId 日程id (string query required)
     * type 类型添加|删除 (string query required)
     * adminIds 参与人员 (array query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/changeScheduleMember", p, c),
  },
  dingtalk_addLog: {
    /*
     * 添加日志
     * createId 日志创建人 (integer query required)
     * templateId 日志模板id (string query required)
     * fieldNames 字段名称 (array query required)
     * fieldValues 字段值 (array query required)
     * toAdminIds 接受人id (array query )
     * groupIds 接受人群id (array query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/addLog", p, c),
  },
  dingtalk_getInstanceResp: {
    /*
     * 获取钉钉审批实例
     * instanceId 审批实例id (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/dingtalk/getInstanceResp", p, c),
  },
  dingtalk_removeSchedule: {
    /*
     * 删除日程
     * createId 日程创建人 (integer query required)
     * scheduleId 日程id (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/dingtalk/removeSchedule", p, c),
  },

  /**
   *
   */
  dingTask_finishTask: {
    /*
     * 完成代办
     * adminId adminId (integer query )
     * contentId 来源ID (integer query )
     */
    put: (p, c) => $.put("/api/bms/extension/dingTask/finishTask", p, c),
  },
  dingTask_save: {
    /*
     * 新增代办
     * targetAdminId targetAdminId (integer query )
     * contentId 来源ID (integer query )
     * title 代办标题 (string query )
     * description 代办描述 (string query )
     * deadline 截止时间(2022-08-05 23:59:59) (string query )
     * appUrl appUrl (string query )
     * pcUrl pcUrl (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingTask/save", p, c),
  },
  dingTask_removeTask: {
    /*
     * 删除代办
     * adminId adminId (integer query )
     * contentId 来源ID (integer query )
     */
    delete: (p, c) => $.delete("/api/bms/extension/dingTask/removeTask", p, c),
  },

  /**
   * 对账单
   */
  bill_updateType: {
    /*
     * 更新类型类型
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/bill/updateType", p, c),
  },
  bill_setSummaryType: {
    /*
     * 设置摘要类型
     * summaryTypes 摘要类型json字符串 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/bill/setSummaryType", p, c),
  },
  bill_refresh: {
    /*
     * 刷新
     * date 日期：yyyy-MM-dd (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/bill/refresh", p, c),
  },
  bill_refreshByAccount: {
    /*
     * 刷新
     * account 账号 (string query )
     * date 日期：yyyy-MM-dd (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/bill/refreshByAccount", p, c),
  },
  bill_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/bill/list", p, c),
  },
  bill_getSummaryType: {
    /*
     * 获取摘要类型
     */
    get: (p, c) => $.get("/api/bms/extension/bill/getSummaryType", p, c),
  },
  bill_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/bill/export", p, c),
  },

  /**
   * 企业微信
   */
  wecom_refreshAccessToken: {
    /*
     * 刷新企微的AccessToken
     * appName App名称，企微业务助手 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/refreshAccessToken", p, c),
  },
  wecom_callback: {
    /*
     * undefined
     * msg_signature  (string query )
     * timestamp  (string query )
     * nonce  (string query )
     * body  (object body )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/callback", p, c),
  },
  wecom_getWeComConfig: {
    /*
     * 获取签名
     * appName App名称，企微业务助手 (string query required)
     * url 网页的URL， 不包含#及其后面部分 (string query required)
     * agentFlag 获取应用的JsApiTicket传1，企业的传0 (integer query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getWeComConfig", p, c),
  },
  wecom_getUserIdByPhone: {
    /*
     * getUserIdByPhone
     * phone phone (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getUserIdByPhone", p, c),
  },
  wecom_getInfoByCode: {
    /*
     * 使用code获取登录信息，返回40029说明code过期
     * appName App名称，企微业务助手 (string query required)
     * code 登录时获取的 code (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getInfoByCode", p, c),
  },

  /**
   * 企微学生
   */
  wechat_customer_syncStatus: {
    /*
     * 查询分配结果
     * handoverUserId 原负责人企微ID (string query required)
     * takeoverUserId 接收人企微ID  (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/wechat/customer/syncStatus", p, c),
  },
  wechat_customer_reAssign: {
    /*
     * 重新分配, 状态为未知或发起失败可
     * id ID (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/customer/reAssign", p, c),
  },
  wechat_customer_assign: {
    /*
     * 在职分配-测试
     * handoverUserId 原负责人企微ID (string query required)
     * originHeaderTeacherId 原班主任ID (integer query required)
     * takeoverUserId 接收人企微ID (string query required)
     * newHeaderTeacherId 接收班主任ID (integer query required)
     * externalUserId 学生企微ID (string query required)
     * schoolRollId 合同编号 (integer query required)
     * msg 转移成功后发给客户的消息，最多200个字符，不填使用默认文案 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/customer/assign", p, c),
  },
  wechat_getSignature: {
    /*
     * 获取签名
     * platform 平台 (string query required)
     * url url (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getSignature", p, c),
  },
  wechat_getAccessToken: {
    /*
     * 获取AccessToken
     * platform 平台 (string query required)
     * category 分类 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getAccessToken", p, c),
  },
  wechat_decryptMiniProgram: {
    /*
     * 小程序数据解密,解密后数据自动处理
     * platform 平台 (string query required)
     * encryptedData 加密数据 (string query required)
     * iv iv (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/decryptMiniProgram", p, c),
  },
  wechat_customer_listStudent: {
    /*
     * 企微学生
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listStudent", p, c),
  },
  wechat_customer_listSimpleAdmin: {
    /*
     * 简易企微员工列表
     * appName App名称，企微业务助手或中军 (string query required)
     * followUserFlag 是否开通了联系客户功能 (string query )
     * saveRecordFlag 员工是否开启会话存档 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listSimpleAdmin", p, c),
  },
  wechat_customer_listEmployee: {
    /*
     * 企微员工
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listEmployee", p, c),
  },
  wechat_customer_listAssignRecord: {
    /*
     * 企微分配记录
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listAssignRecord", p, c),
  },
  wechat_customer_exportAssignRecord: {
    /*
     * 导出企微分配记录
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/exportAssignRecord", p, c),
  },
  wechat_checkOpenId: {
    /*
     * 检查openId
     * platform 平台 (string query required)
     * type 类型：小程序，公众号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/checkOpenId", p, c),
  },

  /**
   * 模板文件
   */
  templateFile: {
    /*
     * 添加
     * file  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/templateFile", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/templateFile", p, c),
  },
  templateFile_renderDocToPdf: {
    /*
     * 渲染Word模板
     * platform 平台 (string query required)
     * name 模板名称 (string query required)
     * schoolRollId 合同id (integer query required)
     * signImageKey 签名图片key (string query )
     * signImage 签名图片 (string query )
     * targetFileType 目标文件类型：docx，pdf (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/templateFile/renderDocToPdf", p, c),
  },
  templateFile_listType: {
    /*
     * 模板类型列表
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listType", p, c),
  },
  templateFile_listSubType: {
    /*
     * 模板子类型列表
     * platform 平台 (string query required)
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listSubType", p, c),
  },
  templateFile_listSkillTrain: {
    /*
     * 模板文件列表（技能培训）
     */
    get: (p, c) =>
      $.get("/api/bms/extension/templateFile/listSkillTrain", p, c),
  },
  templateFile_listSelfTaught: {
    /*
     * 模板文件列表（自考平台）
     */
    get: (p, c) =>
      $.get("/api/bms/extension/templateFile/listSelfTaught", p, c),
  },
  templateFile_listName: {
    /*
     * 模板名称列表
     * platform 平台 (string query required)
     * type 类型 (string query required)
     * subType 子类型 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listName", p, c),
  },
  templateFile_listGeo: {
    /*
     * 模板文件列表（GEO平台）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listGeo", p, c),
  },
  templateFile_listExemptionDegree: {
    /*
     * 模板文件列表（免试专升本）
     */
    get: (p, c) =>
      $.get("/api/bms/extension/templateFile/listExemptionDegree", p, c),
  },
  templateFile_listContinue: {
    /*
     * 模板文件列表（继续教育）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listContinue", p, c),
  },
  templateFile_listArmySkill: {
    /*
     * 模板文件列表（中军职达）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listArmySkill", p, c),
  },
  templateFile_listAigc: {
    /*
     * 模板文件列表（AIGC平台）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listAigc", p, c),
  },
  templateFile_listAdult: {
    /*
     * 模板文件列表（学历教育）
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/listAdult", p, c),
  },
  templateFile_getTemplateInfo: {
    /*
     * 获取模板信息
     * platform 平台 (string query required)
     * name 模板名称 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/templateFile/getTemplateInfo", p, c),
  },
  templateFile_getFileUrl: {
    /*
     * 获取文件地址
     * siteType 学校类型 (string query required)
     * type 类型 (string query required)
     * subType 子类型 (string query )
     * siteId 学校id (integer query )
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/getFileUrl", p, c),
  },
  templateFile_details: {
    /*
     * 添加
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/extension/templateFile/details", p, c),
  },

  /**
   * 建议箱
   */
  suggestionBox_rejectImplement: {
    /*
     * 暂不采纳操作
     * id 建议ID (integer query required)
     * implementComment 暂不采纳说明 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/suggestionBox/rejectImplement", p, c),
  },
  suggestionBox_onlineApply: {
    /*
     * 线上提交建议申请
     * suggestionBox  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/suggestionBox/onlineApply", p, c),
  },
  suggestionBox_implement: {
    /*
     * 落地操作
     * id 建议ID (integer query required)
     * implementComment 落地说明 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/suggestionBox/implement", p, c),
  },
  suggestionBox_audit: {
    /*
     * 审核建议
     * id 建议ID (integer query required)
     * status 状态 (string query required)
     * auditComment 审核说明 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/suggestionBox/audit", p, c),
  },
  suggestionBox_adminAdd: {
    /*
     * 后台录入建议
     * suggestionBox  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/suggestionBox/adminAdd", p, c),
  },
  suggestionBox_myList: {
    /*
     * 我的建议列表
     */
    get: (p, c) => $.get("/api/bms/extension/suggestionBox/myList", p, c),
  },
  suggestionBox_list: {
    /*
     * 建议列表
     */
    get: (p, c) => $.get("/api/bms/extension/suggestionBox/list", p, c),
  },
  suggestionBox_detail: {
    /*
     * 建议详情
     * suggestionCode 建议编号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/suggestionBox/detail", p, c),
  },

  /**
   * 支付配置
   */
  payConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/payConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/payConfig", p, c),
  },
  payConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/payConfig/list", p, c),
  },
  payConfig_listSimple: {
    /*
     * 简易列表，id为商户id
     * type 类型：支付宝、微信、支付宝小程序、汇付 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/payConfig/listSimple", p, c),
  },
  payConfig_listAccountByType: {
    /*
     * 根据类型获取账号列表
     * type 类型：支付宝、微信、汇付 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/extension/payConfig/listAccountByType", p, c),
  },

  /**
   * 门店
   */
  merchantShop: {
    /*
     * 添加
     * shop  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/merchantShop", p, c),
  },
  merchantShop_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantShop/list", p, c),
  },
  merchantShop_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantShop/listSimple", p, c),
  },

  /**
   * 抽奖记录
   */
  lotteryRecord_studentDraw: {
    /*
     * 学生抽奖（通过身份证号）
     * idCardNo 身份证号 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/lotteryRecord/studentDraw", p, c),
  },
  lotteryRecord_draw: {
    /*
     * 抽奖（销售）
     * adminId 管理员id (integer query )
     */
    post: (p, c) => $.post("/api/bms/extension/lotteryRecord/draw", p, c),
  },
  lotteryRecord_distributePrize: {
    /*
     * 发放奖品
     * schoolRollId 合同编号 (integer query required)
     * type 类型: 销售/学生 (string query required)
     * distributeTime 奖品发放时间 (string query required)
     * remark 备注 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/lotteryRecord/distributePrize", p, c),
  },
  lotteryRecord_remainCount: {
    /*
     * 获取剩余抽奖次数
     * adminId 管理员id (integer query )
     */
    get: (p, c) => $.get("/api/bms/extension/lotteryRecord/remainCount", p, c),
  },
  lotteryRecord_managerExport: {
    /*
     * 抽奖管理列表导出(招生老师)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/lotteryRecord/managerExport", p, c),
  },
  lotteryRecord_manageList: {
    /*
     * 抽奖管理列表
     */
    get: (p, c) => $.get("/api/bms/extension/lotteryRecord/manageList", p, c),
  },
  lotteryRecord_list: {
    /*
     * 抽奖列表
     * adminId 管理员id (integer query )
     * status 状态: 已抽奖/未抽奖/全部 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/lotteryRecord/list", p, c),
  },
  lotteryRecord_listStudentDrawn: {
    /*
     * 学生已抽奖列表（按班主任/部门过滤）
     */
    get: (p, c) =>
      $.get("/api/bms/extension/lotteryRecord/listStudentDrawn", p, c),
  },
  lotteryRecord_getLotteryStatus: {
    /*
     * 获取学生抽奖状态（通过身份证号）
     * idCardNo 身份证号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/lotteryRecord/getLotteryStatus", p, c),
  },
  lotteryRecord_exportStudentDrawn: {
    /*
     * 学生抽奖记录列表导出
     */
    get: (p, c) =>
      $.get("/api/bms/extension/lotteryRecord/exportStudentDrawn", p, c),
  },

  /**
   * id关联表
   */
  idAssociation_setContentId: {
    /*
     * 设置内容id
     * type 类型 (string query required)
     * associationId 关联id (integer query required)
     * contentIds 内容id (array query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/idAssociation/setContentId", p, c),
  },
  idAssociation_listContentId: {
    /*
     * 通过类型和关联字段获取内容id
     * type 类型 (string query required)
     * associationId 关联id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/idAssociation/listContentId", p, c),
  },

  /**
   * 文件导入导出
   */
  fileUploadExport_saveUpload: {
    /*
     * 添加导入
     * fileUploadExport  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/fileUploadExport/saveUpload", p, c),
  },
  fileUploadExport_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/fileUploadExport/list", p, c),
  },

  /**
   * 快递查询
   */
  expressInfo_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/upload", p, c),
  },
  expressInfo_subscribe: {
    /*
     * 订阅回调-测试
     * expressNo 快递单号 (string query required)
     * companyName 快递公司名称 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/subscribe", p, c),
  },
  expressInfo_save: {
    /*
     * 添加编辑
     * company  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/save", p, c),
  },
  expressInfo_query: {
    /*
     * 查询快递信息
     * expressNo 快递单号 (string query required)
     * companyName 快递公司名称 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/query", p, c),
  },
  expressInfo_callback: {
    /*
     * 接收回调
     * sign sign (string query required)
     * param param (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/callback", p, c),
  },
  expressInfo_listCompany: {
    /*
     * 列表-基础平台-扩展管理-快递公司配置
     */
    get: (p, c) => $.get("/api/bms/extension/expressInfo/listCompany", p, c),
  },
  expressInfo_exportCompany: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/expressInfo/exportCompany", p, c),
  },

  /**
   * 列表标签
   */
  columnLabel: {
    /*
     * 添加
     * label  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/columnLabel", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/columnLabel", p, c),
  },
  columnLabel_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/list", p, c),
  },
  columnLabel_listType: {
    /*
     * 类型列表
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/listType", p, c),
  },
  columnLabel_listSimple: {
    /*
     * 简易列表
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/listSimple", p, c),
  },

  /**
   * 地址信息
   */
  addressInfo: {
    /*
     * 编辑
     * info  ( query required)
     */
    post: (p, c) => $.post("/api/bms/extension/addressInfo", p, c),
  },
  addressInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/addressInfo/list", p, c),
  },
  addressInfo_getByAddress: {
    /*
     * 根据地址获取
     * address  (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/addressInfo/getByAddress", p, c),
  },

  /**
   * 企微聊天记录
   */
  wechatChatRecord_listHeaderTeacherChatRecords: {
    /*
     * 获取班主任与学生某天的企微聊天记录
     * date 日期 yyyy-MM-dd (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/extension/wechatChatRecord/listHeaderTeacherChatRecords",
        p,
        c
      ),
  },

  /**
   * 汇付付款人信息
   */
  huifuPayer_getPayerId: {
    /*
     * 获取付款人id
     * payAccount 收款账号 (string query required)
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/huifuPayer/getPayerId", p, c),
  },
};
